function calculateMoneyEarned(price: number) {
    return price - calculateFees(price) - calculateStripeFees(price);
}

function calculateFees(price: number) {
    return price*0.185;
}

function calculatePriceWithoutStripeFees(price: number) {
    return price - calculateStripeFees(price);
}

function calculateStripeFees(price: number) {
    if(price == 0) return 0;
    return price*0.025+0.25;
}

function formatPrice(price: number) {
    return (Math.round(price * 100) / 100).toFixed(2);
}

export {calculateMoneyEarned, calculateFees, formatPrice, calculatePriceWithoutStripeFees, calculateStripeFees};